export const alertSelectors = {
  message: (state) => state.message,
  type: (state) => state.type,
  update: (state) => state.update,
}
